import { useEffect, useState } from "react";
import { PageHeaderUi } from "../../ui/PageHeaderUi";
import { DateFormats } from "../../../types/typesConstants";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "antd";
import { ComprobanteCompraTable } from "./ComprobanteCompraTable";
import {
  comprobantecompraStartLoad,
  get_excel_compras_formato_startsoft,
  showFormComprobanteCompra,
} from "../../../actions/compra";
import { ComprobanteCompraScreen } from "./ComprobanteCompraScreen";
import { ComprobanteCompraSearchList } from "./ComprobanteCompraSearchList";
import dayjs from "dayjs";
import { ActionsDropdownBtn, ExcelIcon, NewBtn } from "../../ui";
import { open_file } from "../../../helpers/utils";
import { messageError } from "../../../helpers";
const keysMenuActions = {
  rpt_compras: {
    key: "excel_compras_startsoft",
    label: "Compras",
    icon: <ExcelIcon />,
  },
};
const itemMenuActions = [{ ...keysMenuActions.rpt_compras }];

const ComprobanteCompraListScreen = () => {
  const dispatch = useDispatch();
  const { comprobantesCompra, loading, paginator } = useSelector(
    (state) => state.compra,
  );
  const [loadingReport, setLoadingReport] = useState(false);
  const handleClickMenuActions = async (e) => {
    setLoadingReport(true);
    try {
      if (e.key === keysMenuActions.rpt_compras.key) {
        const searchFilters = JSON.parse(
          localStorage.getItem("SearhFormTable"),
        );

        const file = await get_excel_compras_formato_startsoft({
          fechaemision_after: searchFilters?.fechaemision_after,
          fechaemision_before: searchFilters?.fechaemision_before,
        });
        const name_file = "RegistroCompras_startsoft.xlsx";
        open_file(file, name_file, file?.type);
      }
    } catch (errors) {
      messageError(errors);
    } finally {
      setLoadingReport(false);
    }
  };
  const handleNewComprobante = () => {
    dispatch(showFormComprobanteCompra());
  };

  return (
    <PageHeaderUi
      title="Comprobantes compra"
      subTitle="Listado"
      extra={[
        <ActionsDropdownBtn
          key="acciones"
          menuItems={itemMenuActions}
          onItemsClick={handleClickMenuActions}
          loadingBtn={loadingReport}
        />,
        <NewBtn key="nuevo" onClick={handleNewComprobante} />,
      ]}
    >
      <div style={{ overflow: "hidden" }}>
        <ComprobanteCompraSearchList />
        <Row>
          <Col sm={32} md={32} xl={24}>
            <ComprobanteCompraTable
              comprobantes={comprobantesCompra}
              loading={loading}
              paginator={paginator}
            />
          </Col>
        </Row>
      </div>
    </PageHeaderUi>
  );
};

export const ComprobanteCompraList = () => {
  const { visibleFormComprobanteCompra } = useSelector((state) => state.compra);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      comprobantecompraStartLoad({
        fechaemision_after: dayjs().format(DateFormats.backend),
        fechaemision_before: dayjs().format(DateFormats.backend),
      }),
    );
  }, []);
  if (visibleFormComprobanteCompra) {
    return <ComprobanteCompraScreen />;
  } else {
    return <ComprobanteCompraListScreen />;
  }
};

export default ComprobanteCompraList;
